<template>
  <v-card v-if="report && report.length" class="mt-5 py-3">
    <v-row class="my-3" v-if="report.length">
      <v-col>
        <v-badge
          class="ml-5"
          bordered
          color="info"
          overlap
        >
          <v-chip
              color="info"
              label
              outlined
          >Количество</v-chip>
          <template v-slot:badge>
            <span>{{ report.length }}</span>
          </template>
        </v-badge>
      </v-col>
    </v-row>
    <v-data-table
      v-if="report.length"
      :headers="headers"
      :items="report"
      loading-text="Загрузка..."
      no-data-text="Ничего не найдено"
      hide-default-footer
      group-by="phone"
      dense
      disable-pagination
    >

      <template #[`item.was_skipped`]="{ item }">{{ item.was_skipped ? 'Да' : 'Нет' }}</template>

      <template #[`item.actions`]="{ item }">
        <v-btn v-if="item.uid" icon :to="{name: 'SpeechAnalysisCall', params: {uid: item.uid}}" target="_blank">
          <v-icon dense>mdi-dock-window</v-icon>
        </v-btn>
      </template>

    </v-data-table>
  </v-card>
</template>


<script>

export default {
  name: 'IgnoreReport',
  props: {
    report: {
      type: Array
    },
  },
  data() {
    return {
      headers: [
        { text: 'Имя', value: 'agent'},
        { text: 'Проект', value: 'project'},
        { text: 'Очередь', value: 'queue'},
        { text: 'Телефон', value: 'phone'},
        { text: 'Дата скипа', value: 'skip_date'},
        { text: 'Продолжительность игнора (сек)', value: 'skip_duration'},
        { text: 'Звонок пропущен', value: 'was_skipped'},
        { text: 'Комментарий', value: 'comment', sortable: false, },
        { text: 'Просмотр', value: 'actions', sortable: false, },
      ],
    }
  },

}
</script>


<style scoped lang="scss">

</style>